import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  HostListener,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Store } from "@ngrx/store";
import {
  CustomerHeaderService,
  EntityService,
  SupplierHeaderService,
  DimensionService,
  SegmentCoaService,
  ProfitCenterService,
  ProjectCoaService,
  Pagination,
} from "blg-akaun-ts-lib";
import * as $ from "jquery";
import * as moment from "moment";
import { SearchModelV2 } from "../../models/search-model-v2";
import { SessionSelectors } from "../../modules/session/session-controller/selectors";
import { SessionStates } from "../../modules/session/session-controller/states";
import { AppConfig } from "../../visa";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { SubSink } from "subsink2";
import { BranchComponent } from "../branch/branch.component";
import { CompanyComponent } from "../company/company.component";
import { LocationFromComponent } from "../location-from/location-from.component";
import { LocationToComponent } from "../location-to/location-to.component";
import { SalesAgentSearchComponent } from "../sales-agent-v2/sales-agent.component";
import { WarehouseAdvancedSearchComponent } from "../warehouse-advanced-search-drop-down/warehouse-advanced-search-drop-down.component";
import { PurchaserComponent } from "../purchaser/purchaser.component";
import { CashbookAdvancedSearchDropdownComponent } from "../advanced-search-cashbook-dropdown/advanced-search-cashbook-dropdown.component";
import { SelectBudgetItemComponent } from "../select-budget-item/select-budget-item.component";
import { SelectBudgetRegisterComponent } from "../select-budget-register/select-budget-register.component";
import { SelectBudgetFiscalYearComponent } from "../select-budget-fiscal-year/select-budget-fiscal-year.component";
@Component({
  selector: "app-advanced-search-v2",
  templateUrl: "./advanced-search-v2.component.html",
  styleUrls: ["./advanced-search-v2.component.scss"],
})
export class AdvancedSearchV2Component implements OnInit {
  @Input() advSearchModel: SearchModelV2;
  @Input() id: string;
  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;
  @Input() readPermissionDefintion;
  @Output() search = new EventEmitter<any>();
  @Input() votebookGuid;

  @ViewChild(BranchComponent) branchComponent: BranchComponent;
  @ViewChild(PurchaserComponent) purchaserComponent: PurchaserComponent;
  @ViewChild(CompanyComponent) companyComponent: CompanyComponent;
  @ViewChild(LocationFromComponent)
  locationFromComponent: LocationFromComponent;
  @ViewChild(LocationToComponent) locationToComponent: LocationToComponent;
  @ViewChild(SalesAgentSearchComponent)
  salesAgentComponent: SalesAgentSearchComponent;
  @ViewChild(WarehouseAdvancedSearchComponent)
  warehouseAdvancedSearchDropdownComponent: WarehouseAdvancedSearchComponent;
  @ViewChild(CashbookAdvancedSearchDropdownComponent)
  cashbookAdvancedSearchDropdownComponent: CashbookAdvancedSearchDropdownComponent;
  @ViewChild(SelectBudgetItemComponent)
  selectBudgetItemComponent: SelectBudgetItemComponent;
  @ViewChild(SelectBudgetRegisterComponent)
  selectBudgetRegisterComponent: SelectBudgetRegisterComponent;
  @ViewChild(SelectBudgetFiscalYearComponent)
  selectBudgetFiscalYearComponent: SelectBudgetFiscalYearComponent;
  // @ViewChild(DeliveryRegionComponent) deliveryRegionComponent: DeliveryRegionComponent;

  branchGuids: [] = [];
  purchaserGuids: [] = [];
  companyGuids: [] = [];
  locationGuidsFrom: [] = [];
  locationGuidsTo: [] = [];
  salesAgentGuids: [] = [];
  deliveryRegionGuids: [] = [];
  warehouseGuids: [] = [];
  cashbookGuids: [] = [];
  budgetItemGuids: [] = [];
  budgetRegisterGuids: [] = [];
  budgetFiscalYearGuids: [] = [];
  isAdvanced: boolean;
  inputArray: any[];
  advForm: FormGroup;
  optionArray = {};
  filter = "";
  basicSearchQuery = "";
  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];

  public customerForm: FormGroup;
  customerGuids: [] = [];
  searchedCustomers$: Observable<any[]>;
  customers: any[] = [];
  customerSearch: boolean;

  public supplierForm: FormGroup;
  supplierGuids: [] = [];
  searchedSuppliers$: Observable<any[]>;
  suppliers: any[] = [];
  supplierSearch: boolean;

  public entityForm: FormGroup;
  entityGuids: [] = [];
  searchedEntities$: Observable<any[]>;
  entities: any[] = [];
  entitySearch: boolean;

  public glDimensionForm: FormGroup;
  glDimensionGuids: [] = [];
  searchedGlDimensions$: Observable<any[]>;
  glDimensions: any[] = [];
  glDimensionSearch: boolean;

  public segmentForm: FormGroup;
  segmentGuids: [] = [];
  searchedSegments$: Observable<any[]>;
  segments: any[] = [];
  segmentSearch: boolean;

  public profitCenterForm: FormGroup;
  profitCenterGuids: [] = [];
  searchedProfitCenters$: Observable<any[]>;
  profitCenters: any[] = [];
  profitCenterSearch: boolean;

  public projectForm: FormGroup;
  projectGuids: [] = [];
  searchedProjects$: Observable<any[]>;
  projects: any[] = [];
  projectSearch: boolean;

  // advanced search fields for stock requisition
  docNo = "";
  trackingId = "";
  ref = "";
  desc = "";
  mktOrderNo = "";

  // for cashbook txn line
  payee = "";
  amountDebit = 0;
  amountCredit = 0;

  includeEstimateDeliveryDateControl: FormControl = new FormControl(false);
  includeCreationDateControl: FormControl = new FormControl(false);
  includeTxnDateControl: FormControl = new FormControl(true);
  includeChequeDateControl: FormControl = new FormControl(false);

  defaultColDef = {
    filter: "agTextColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 200,
    flex: 2,
    sortable: true,
    resizable: true,
    suppressCsvExport: true,
  };

  gridApi;

  columnsDefs = [
    {
      headerName: "Code",
      field: "code",
      comparator: (valueA, valueB) =>
        valueA.toLowerCase().localeCompare(valueB.toLowerCase()),
      width: 110,
      suppressSizeToFit: true,
      cellStyle: () => ({ "text-align": "left" }),
    },
    {
      headerName: "Name ",
      field: "name",
      comparator: (valueA, valueB) =>
        valueA.toLowerCase().localeCompare(valueB.toLowerCase()),
      width: 110,
      suppressSizeToFit: true,
      cellStyle: () => ({ "text-align": "left" }),
    },
    {
      headerName: "Phone",
      field: "phone",
      suppressSizeToFit: true,
      cellStyle: () => ({ "text-align": "left" }),
    },
    {
      headerName: "Email",
      field: "email",
      suppressSizeToFit: true,
      cellStyle: () => ({ "text-align": "left" }),
    },
  ];

  departmentHdrColumnsDefs = [
    {
      headerName: "Code",
      field: "code",
      comparator: (valueA, valueB) =>
        valueA.toLowerCase().localeCompare(valueB.toLowerCase()),
      width: 110,
      suppressSizeToFit: true,
      cellStyle: () => ({ "text-align": "left" }),
    },
    {
      headerName: "Name",
      field: "name",
      comparator: (valueA, valueB) =>
        valueA.toLowerCase().localeCompare(valueB.toLowerCase()),
      width: 110,
      suppressSizeToFit: true,
      cellStyle: () => ({ "text-align": "left" }),
    },
  ];

  resetListing: boolean = false;
  isEmpty: boolean = true;

  constructor(
    private customerService: CustomerHeaderService,
    private supplierService: SupplierHeaderService,
    private entityService: EntityService,
    private snackBar: MatSnackBar,
    private readonly sessionStore: Store<SessionStates>,
    private glDimensionService: DimensionService,
    private segmentCoaService: SegmentCoaService,
    private profitCenterService: ProfitCenterService,
    private projectCoaService: ProjectCoaService,
  ) {
    this.isAdvanced = false;
    this.customerSearch = false;
    this.supplierSearch = false;
    this.entitySearch = false;
    this.glDimensionSearch = false;
    this.segmentSearch = false;
    this.profitCenterSearch = false;
    this.projectSearch = false;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: KeyboardEvent): void {
    this.isAdvanced = false;
  }

  ngOnInit(): void {
    this.advForm = this.advSearchModel.form;
    this.inputArray = Object.entries(this.advSearchModel.dataType).map(
      (e: any) => e.flatMap((f) => f)
    );
    // console.log(this.inputArray);
    // console.log("label", this.advSearchModel.label)
    this.extractOptions();
    $(document).mouseup((ev) => {
      const container = $(`#${this.id}`);
      const calendar = $("mat-calendar");
      const matOption = $("mat-option");
      const backdrop = $(".cdk-overlay-backdrop");
      if (
        !matOption.is(ev.target) &&
        !calendar.is(ev.target) &&
        !container.is(ev.target) &&
        !backdrop.is(ev.target) &&
        matOption.has(ev.target).length === 0 &&
        container.has(ev.target).length === 0 &&
        calendar.has(ev.target).length === 0 &&
        backdrop.has(ev.target).length === 0
      ) {
        container.hide("fast", "swing", (c) => {
          this.isAdvanced = false;
          // this.advForm.reset();
        });
      }
    });

    this.customerForm = new FormGroup({
      criteria: new FormControl(),
    });

    this.supplierForm = new FormGroup({
      criteria: new FormControl(),
    });

    this.entityForm = new FormGroup({
      criteria: new FormControl(),
    });

    this.glDimensionForm = new FormGroup({
      criteria: new FormControl(),
    });

    this.segmentForm = new FormGroup({
      criteria: new FormControl(),
    });

    this.profitCenterForm = new FormGroup({
      criteria: new FormControl(),
    });

    this.projectForm = new FormGroup({
      criteria: new FormControl(),
    });

    if (this.inputArray.some((e) => e.includes("customer"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Customer_Field)
        .subscribe((data) => {
          this.customers = data;
        });
    }

    if (this.inputArray.some((e) => e.includes("entity"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Entity_Field)
        .subscribe((data) => {
          this.entities = data;
        });
    }

    if (this.inputArray.some((e) => e.includes("supplier"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Supplier_Field)
        .subscribe((data) => {
          this.suppliers = data;
        });
    }

    if (this.inputArray.some((e) => e.includes("orderBy"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_OrderBy_Field)
        .subscribe((data) => {
          this.advForm.patchValue({
            orderBy: data,
          });
        });
    }

    if (this.inputArray.some((e) => e.includes("orderBy"))) {
      this.subs.sink = this.sessionStore
        .select(SessionSelectors.selectMasterSettings)
        .subscribe({
          next: (resolve) => {
            this.advForm.patchValue({
              orderBy: resolve?.SORT_ORDER,
            });
          },
        });
    }

    if (this.inputArray.some((e) => e.includes("postingStatus"))) {
      if (this.advForm.controls.hasOwnProperty('postingStatus')) {
        this.subs.sink = this.sessionStore
          .select(SessionSelectors.selectMasterSettings)
          .subscribe({
            next: (resolve) => {
              if (resolve?.DEFAULT_POSTING_STATUS&& (resolve?.DEFAULT_POSTING_STATUS !== 'ALL')) {
                this.advForm.patchValue({
                  postingStatus: resolve?.DEFAULT_POSTING_STATUS,
                });
              }
            },
          });
      }
    }

    if (this.inputArray.some((e) => e.includes("orderBy"))) {
      this.advForm.get("orderBy").valueChanges.subscribe((newValue) => {
        this.viewModelStore.dispatch(
          this.ColumnViewActions.setAdvanceSearch_OrderByField({
            orderBy: newValue,
          })
        );
      });
    }

    if (this.inputArray.some((e) => e.includes("transactionDate"))) {
      var dateRange = moment()
        .subtract(1, "months")
        .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");

      this.viewModelStore
        .select(
          this.ColumnViewSelectors.selectAdvanceSearch_TransactionDateFrom_Field
        )
        .subscribe((data) => {
          if (data) {
            this.advForm.get(["transactionDate", "from"]).patchValue(data);
          } else {
            this.advForm.get(["transactionDate", "from"]).patchValue(dateRange);
          }
        });

      this.viewModelStore
        .select(
          this.ColumnViewSelectors.selectAdvanceSearch_TransactionDateTo_Field
        )
        .subscribe((data) => {
          if (data) {
            this.advForm.get(["transactionDate", "to"]).patchValue(data);
          } else {
            this.advForm.get(["transactionDate", "to"]).patchValue(new Date());
          }
        });

      this.advForm
        .get(["transactionDate", "from"])
        .valueChanges.subscribe((newValue) => {
          this.viewModelStore.dispatch(
            this.ColumnViewActions.setAdvanceSearch_TransactionDateFromField({
              date: newValue,
            })
          );
          this.includeTxnDateControl.setValue(true, { emitEvent: false });
          this.includeCreationDateControl.setValue(false, { emitEvent: false });
        });

      this.advForm
        .get(["transactionDate", "to"])
        .valueChanges.subscribe((newValue) => {
          this.viewModelStore.dispatch(
            this.ColumnViewActions.setAdvanceSearch_TransactionDateToField({
              date: newValue,
            })
          );
          this.includeTxnDateControl.setValue(true, { emitEvent: false });
          this.includeCreationDateControl.setValue(false, { emitEvent: false });
        });
    }

    if (this.inputArray.some((e) => e.includes("glDimension"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_GlDimension_Field)
        .subscribe((data) => {
          this.glDimensions = data;
        });
    }

    if (this.inputArray.some((e) => e.includes("segment"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Segment_Field)
        .subscribe((data) => {
          this.segments = data;
        });
    }

    if (this.inputArray.some((e) => e.includes("profitCenter"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_ProfitCenter_Field)
        .subscribe((data) => {
          this.profitCenters = data;
        });
    }

    if (this.inputArray.some((e) => e.includes("project"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Project_Field)
        .subscribe((data) => {
          this.projects = data;
        });
    }

    // Subscribe to changes in the date fields
    this.subs.sink = this.advForm.get(["creationDate", "from"]).valueChanges.subscribe(() => {
      this.includeCreationDateControl.setValue(true, { emitEvent: false });
      this.includeTxnDateControl.setValue(false, { emitEvent: false });
    });

    this.subs.sink = this.advForm.get(["creationDate", "to"]).valueChanges.subscribe(() => {
      this.includeCreationDateControl.setValue(true, { emitEvent: false });
      this.includeTxnDateControl.setValue(false, { emitEvent: false });
    });

  }

  isTrue(value) {
    if (value === true || value === false) {
      return value;
    } else if (value) {
      return value.includes(true);
    }
    return false;
  }

  isRequired(x) {
    let value = this.advSearchModel.options[x[0]]["required"];
    return this.isTrue(value);
  }

  isMultiple(x) {
    let value = this.advSearchModel.options[x[0]]["multiple"];
    return this.isTrue(value);
  }

  isCheckbox(x) {
    let value = this.advSearchModel.options[x[0]]["checkbox"];
    return this.isTrue(value);
  }

  extractOptions = (fieldName?, fieldValue?) =>
    this.inputArray
      .filter((x) => x[1] === "select")
      .filter((x) => (fieldName ? x[0] === fieldName : true))
      .forEach((x) => {
        const options = x[2]
          .flatMap((e) => e)
          .filter((e) =>
            fieldValue
              ? e.toLowerCase().includes(fieldValue.toLowerCase())
              : true
          );
        this.optionArray[x[0]] = options;
      });

  onGridReady(params) {
    const apiVisa = AppConfig.apiVisa;
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
  }

  searchToggle() {
    const container = $(`#${this.id}`);
    if (!this.isAdvanced) {
      this.isAdvanced = true;
      container.show("fast", "swing", (c) => (this.isAdvanced = true));
    }
  }

  customerReturn() {
    const container = $(`#${this.id}`);
    if (!this.isAdvanced) {
      this.isAdvanced = true;
      this.customerSearch = false;
      this.customerForm.reset();
      this.searchedCustomers$ = null;
      container.show("fast", "swing", (c) => (this.isAdvanced = true));
    }
  }

  entityReturn() {
    const container = $(`#${this.id}`);
    if (!this.isAdvanced) {
      this.isAdvanced = true;
      this.entitySearch = false;
      this.entityForm.reset();
      this.searchedEntities$ = null;
      container.show("fast", "swing", (c) => (this.isAdvanced = true));
    }
  }

  supplierReturn() {
    const container = $(`#${this.id}`);
    if (!this.isAdvanced) {
      this.isAdvanced = true;
      this.supplierSearch = false;
      this.supplierForm.reset();
      this.searchedSuppliers$ = null;
      container.show("fast", "swing", (c) => (this.isAdvanced = true));
    }
  }

  glDimensionReturn() {
    const container = $(`#${this.id}`);
    if (!this.isAdvanced) {
      this.isAdvanced = true;
      this.glDimensionSearch = false;
      this.glDimensionForm.reset();
      this.searchedGlDimensions$ = null;
      container.show("fast", "swing", (c) => (this.isAdvanced = true));
    }
  }

  segmentReturn() {
    const container = $(`#${this.id}`);
    if (!this.isAdvanced) {
      this.isAdvanced = true;
      this.segmentSearch = false;
      this.segmentForm.reset();
      this.searchedSegments$ = null;
      container.show("fast", "swing", (c) => (this.isAdvanced = true));
    }
  }

  profitCenterReturn() {
    const container = $(`#${this.id}`);
    if (!this.isAdvanced) {
      this.isAdvanced = true;
      this.profitCenterSearch = false;
      this.profitCenterForm.reset();
      this.searchedProfitCenters$ = null;
      container.show("fast", "swing", (c) => (this.isAdvanced = true));
    }
  }

  projectReturn() {
    const container = $(`#${this.id}`);
    if (!this.isAdvanced) {
      this.isAdvanced = true;
      this.projectSearch = false;
      this.projectForm.reset();
      this.searchedProjects$ = null;
      container.show("fast", "swing", (c) => (this.isAdvanced = true));
    }
  }

  customerSearchToggle() {
    const container = $(`#${this.id}`);
    if (!this.customerSearch) {
      this.isAdvanced = false;
      this.customerSearch = true;
      container.show("fast", "swing", (c) => (this.customerSearch = true));
    }
  }

  entitySearchToggle() {
    const container = $(`#${this.id}`);
    if (!this.entitySearch) {
      this.isAdvanced = false;
      this.entitySearch = true;
      container.show("fast", "swing", (c) => (this.entitySearch = true));
    }
  }

  supplierSearchToggle() {
    const container = $(`#${this.id}`);
    if (!this.supplierSearch) {
      this.isAdvanced = false;
      this.supplierSearch = true;
      container.show("fast", "swing", (c) => (this.supplierSearch = true));
    }
  }

  glDimensionSearchToggle() {
    const container = $(`#${this.id}`);

    let pagination = new Pagination();
    pagination.conditionalCriteria = [
      {
        columnName: "orderBy",
        operator: "=",
        value: "code"
      },
      {
        columnName: "limit",
        operator: "=",
        value: "200"
      }
    ]

    if (!this.glDimensionSearch) {
      this.isAdvanced = false;
      this.glDimensionSearch = true;
      container.show("fast", "swing", (c) => (this.glDimensionSearch = true));

      // Display all available Gl Dimensions even if without keyword searching - only do for gl dimension field & set limit as 200 for now
      this.searchedGlDimensions$ = this.glDimensionService
      .getByCriteria(pagination,AppConfig.apiVisa)
      .pipe(
        map((response) => {
          return response.data
            .map((inner) => (
              {
                guid : inner.bl_fi_mst_gl_dimension.guid,
                code : inner.bl_fi_mst_gl_dimension.code,
                name : inner.bl_fi_mst_gl_dimension.name,
              }
            ))
        })
      );
    }
  }

  segmentSearchToggle() {
    const container = $(`#${this.id}`);
    if (!this.segmentSearch) {
      this.isAdvanced = false;
      this.segmentSearch = true;
      container.show("fast", "swing", (c) => (this.segmentSearch = true));
    }
  }

  profitCenterSearchToggle() {
    const container = $(`#${this.id}`);
    if (!this.profitCenterSearch) {
      this.isAdvanced = false;
      this.profitCenterSearch = true;
      container.show("fast", "swing", (c) => (this.profitCenterSearch = true));
    }
  }

  projectSearchToggle() {
    const container = $(`#${this.id}`);
    if (!this.projectSearch) {
      this.isAdvanced = false;
      this.projectSearch = true;
      container.show("fast", "swing", (c) => (this.projectSearch = true));
    }
  }

  reset() {
    this.advForm.reset();
    this.resetListing = true;
    this.isEmpty = true;
    this.viewModelStore.dispatch(this.ColumnViewActions.resetAdvanceSearch());
    this.branchGuids = [];
    this.purchaserGuids = [];
    this.companyGuids = [];
    this.entityGuids = [];
    this.salesAgentGuids = [];
    this.deliveryRegionGuids = [];
    this.warehouseGuids = [];
    this.cashbookGuids = [];
    this.customerGuids = [];
    this.locationGuidsFrom = [];
    this.locationGuidsTo = [];
    this.supplierGuids = [];
    this.suppliers = [];
    this.customers = [];
    this.entities = [];
    this.glDimensionGuids = [];
    this.glDimensions = [];
    this.segmentGuids = [];
    this.segments = [];
    this.profitCenterGuids = [];
    this.profitCenters = [];
    this.projectGuids = [];
    this.projects = [];
    if (this.inputArray.some((e) => e.includes("branch"))) {
      this.branchComponent.onReset();
    }
    if (this.inputArray.some((e) => e.includes("purchaser"))) {
      this.purchaserComponent.onReset();
    }
    if (this.inputArray.some((e) => e.includes("company"))) {
      this.companyComponent.onReset();
    }
    if (this.inputArray.some((e) => e.includes("salesAgent"))) {
      this.salesAgentComponent.onReset();
    }
    if (this.inputArray.some((e) => e.includes("locationFrom"))) {
      this.locationFromComponent.onReset();
    }
    if (this.inputArray.some((e) => e.includes("locationTo"))) {
      this.locationToComponent.onReset();
    }
    if (this.inputArray.some((e) => e.includes("warehouse"))) {
      this.warehouseAdvancedSearchDropdownComponent.onReset();
    }
    if (this.inputArray.some((e) => e.includes("cashbook"))) {
      this.cashbookAdvancedSearchDropdownComponent.onReset();
    }
    if (this.inputArray.some((e) => e.includes("budgetItem"))) {
      this.selectBudgetItemComponent.onReset();
    }
    if (this.inputArray.some((e) => e.includes("budgetRegister"))) {
      this.selectBudgetRegisterComponent.onReset();
    }
    if (this.inputArray.some((e) => e.includes("budgetFiscalYear"))) {
      this.selectBudgetFiscalYearComponent.onReset();
    }
  }

  optionSearchFilter(query) {
    const fieldName = query.target.parentNode.parentNode.id;
    this.extractOptions(fieldName, query.target.value);
  }

  truncate(str, no_words) {
    return str.split(" ").splice(0, no_words).join(" ");
  }

  /**
   * The three entity look-ups below replace raw SELECTs that went through
   * SubQueryService. All three hit an entity endpoint whose UoW path is
   * EntityUow.whereClauseCriteriaForSnapshot, which applies:
   *   - `search_word` via EntityUowHelper.generateSearchWordCondition (bound and
   *     ILIKE over id_no, name, nickname, the entity-type code column, descr,
   *     phone, email, website_url, tax_reg_number, ...). With is_customer /
   *     is_supplier set by the endpoint path, the code column is customer_code /
   *     supplier_code respectively; with no is_* scope it is the OR of all four
   *     code columns.
   *   - `status` via EntityUowHelper.whereClauseHdr.
   * The is_customer / is_supplier predicates the old SQL spelled out are applied
   * by EntityController from the entity/customers and entity/suppliers path
   * segments, so they need no criterion of their own.
   *
   * Behaviour note: `search_word` matches a few more columns than the old
   * name/code/phone/email list, so these look-ups are slightly broader.
   */
  searchCustomer() {
    this.searchedCustomers$ = this.customerService
      .getByCriteria(
        new Pagination(0, 5, [
          { columnName: 'status', operator: '=', value: 'ACTIVE' },
          { columnName: 'legacy_entity_category', operator: '=', value: 'CUSTOMER' },
          { columnName: 'search_word', operator: '=', value: (this.customerForm.value.criteria || '').trim() }
        ]),
        AppConfig.apiVisa
      )
      .pipe(
        map((response) =>
          response.data.map((container: any) => ({
            guid: container.bl_fi_mst_entity_hdr.guid,
            code: container.bl_fi_mst_entity_hdr.customer_code,
            name: container.bl_fi_mst_entity_hdr.name,
            email: container.bl_fi_mst_entity_hdr.email,
            phone: container.bl_fi_mst_entity_hdr.phone,
          }))
        )
      );
  }

  removeCustomer(customer: string): void {
    const index = this.customers.indexOf(customer);
    if (index >= 0) {
      this.customers.splice(index, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_CustomerField({
        customers: this.customers,
      })
    );
  }

  onRowClickedCustomer(e: any) {
    this.customers.push(e);
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_CustomerField({
        customers: this.customers,
      })
    );
    this.snackBar.open(`Customer Selected`);
    this.customerReturn();
  }

  searchEntity() {
    this.searchedEntities$ = this.entityService
      .getByCriteria(
        new Pagination(0, 20, [
          { columnName: 'status', operator: '=', value: 'ACTIVE' },
          { columnName: 'search_word', operator: '=', value: (this.entityForm.value.criteria || '').trim() }
        ]),
        AppConfig.apiVisa
      )
      .pipe(
        map((response) =>
          response.data.map((container: any) => ({
            guid: container.bl_fi_mst_entity_hdr.guid,
            code:
              container.bl_fi_mst_entity_hdr.customer_code ||
              container.bl_fi_mst_entity_hdr.supplier_code ||
              container.bl_fi_mst_entity_hdr.employee_code ||
              container.bl_fi_mst_entity_hdr.merchant_code,
            name: container.bl_fi_mst_entity_hdr.name,
            email: container.bl_fi_mst_entity_hdr.email,
            phone: container.bl_fi_mst_entity_hdr.phone,
          }))
        )
      );
  }

  removeEntity(entity: string): void {
    const index = this.entities.indexOf(entity);
    if (index >= 0) {
      this.entities.splice(index, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_EntityField({
        entities: this.entities,
      })
    );
  }

  onRowClickedEntity(e: any) {
    this.entities.push(e);
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_EntityField({
        entities: this.entities,
      })
    );
    this.snackBar.open(`Entity Selected`);
    this.entityReturn();
  }

  searchSupplier() {
    this.searchedSuppliers$ = this.supplierService
      .getByCriteria(
        new Pagination(0, 5, [
          { columnName: 'status', operator: '=', value: 'ACTIVE' },
          { columnName: 'legacy_entity_category', operator: '=', value: 'SUPPLIER' },
          { columnName: 'search_word', operator: '=', value: (this.supplierForm.value.criteria || '').trim() }
        ]),
        AppConfig.apiVisa
      )
      .pipe(
        map((response) =>
          response.data.map((container: any) => ({
            guid: container.bl_fi_mst_entity_hdr.guid,
            code: container.bl_fi_mst_entity_hdr.supplier_code,
            name: container.bl_fi_mst_entity_hdr.name,
            email: container.bl_fi_mst_entity_hdr.email,
            phone: container.bl_fi_mst_entity_hdr.phone,
          }))
        )
      );
  }

  removeSupplier(supplier: string): void {
    const index = this.suppliers.indexOf(supplier);
    if (index >= 0) {
      this.suppliers.splice(index, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_SupplierField({
        suppliers: this.suppliers,
      })
    );
  }

  onRowClickedSupplier(e: any) {
    // console.log(e);
    this.suppliers.push(e);
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_SupplierField({
        suppliers: this.suppliers,
      })
    );
    this.snackBar.open(`Supplier Selected`);
    this.supplierReturn();
  }

  searchGlDimension() {
    let pagination = new Pagination;
    pagination.conditionalCriteria = [
      {
        columnName: "search_word",
        operator: "=",
        value: this.glDimensionForm.value.criteria,
      },
    ]
    this.searchedGlDimensions$ = this.glDimensionService
      .getByCriteria(pagination, AppConfig.apiVisa)
      .pipe(
        map((response) => {
          return response.data
            .map((inner) => (
              {
                guid : inner.bl_fi_mst_gl_dimension.guid,
                code : inner.bl_fi_mst_gl_dimension.code,
                name : inner.bl_fi_mst_gl_dimension.name,
              }
            ))
        })
      );
  }

  removeGlDimension(glDimension: string): void {
    const index = this.glDimensions.indexOf(glDimension);
    if (index >= 0) {
      this.glDimensions.splice(index, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_GlDimensionField({
        glDimensions: this.glDimensions,
      })
    );
  }

  onRowClickedGlDimension(e: any) {
    if (this.glDimensions.includes(e)) {
      this.snackBar.open(`This GL Dimension is already in the selected list`);
    }
    else {
      this.glDimensions.push(e);
      this.viewModelStore.dispatch(
        this.ColumnViewActions.setAdvanceSearch_GlDimensionField({
          glDimensions: this.glDimensions,
        })
      );
      this.snackBar.open(`GL Dimension Selected`);
    }
  }

  searchSegment() {
    let pagination = new Pagination;
    pagination.conditionalCriteria = [
      {
        columnName: "search_word",
        operator: "=",
        value: this.segmentForm.value.criteria,
      },
    ]
    this.searchedSegments$ = this.segmentCoaService
      .getByCriteria(pagination, AppConfig.apiVisa)
      .pipe(
        map((response) => {
          return response.data
            .map((inner) => (
              {
                guid : inner.bl_fi_mst_segment.guid,
                code : inner.bl_fi_mst_segment.code,
                name : inner.bl_fi_mst_segment.name,
              }
            ))
        })
      );
  }

  removeSegment(segment: string): void {
    const index = this.segments.indexOf(segment);
    if (index >= 0) {
      this.segments.splice(index, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_SegmentField({
        segments: this.segments,
      })
    );
  }

  onRowClickedSegment(e: any) {
    if (this.segments.includes(e)) {
      this.snackBar.open(`This Segment is already in the selected list`);
    }
    else {
      this.segments.push(e);
      this.viewModelStore.dispatch(
        this.ColumnViewActions.setAdvanceSearch_SegmentField({
          segments: this.segments,
        })
      );
      this.snackBar.open(`Segment Selected`);
    }
  }

  searchProfitCenter() {
    let pagination = new Pagination;
    pagination.conditionalCriteria = [
      {
        columnName: "search_word",
        operator: "=",
        value: this.profitCenterForm.value.criteria,
      },
    ]
    this.searchedProfitCenters$ = this.profitCenterService
      .getByCriteria(pagination, AppConfig.apiVisa)
      .pipe(
        map((response) => {
          return response.data
            .map((inner) => (
              {
                guid : inner.bl_fi_mst_profit_center.guid,
                code : inner.bl_fi_mst_profit_center.code,
                name : inner.bl_fi_mst_profit_center.name,
              }
            ))
        })
      );
  }

  removeProfitCenter(profitCenter: string): void {
    const index = this.profitCenters.indexOf(profitCenter);
    if (index >= 0) {
      this.profitCenters.splice(index, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_ProfitCenterField({
        profitCenters: this.profitCenters,
      })
    );
  }

  onRowClickedProfitCenter(e: any) {
    if (this.profitCenters.includes(e)) {
      this.snackBar.open(`This Profit Center is already in the selected list`);
    }
    else {
      this.profitCenters.push(e);
      this.viewModelStore.dispatch(
        this.ColumnViewActions.setAdvanceSearch_ProfitCenterField({
          profitCenters: this.profitCenters,
        })
      );
      this.snackBar.open(`Profit Center Selected`);
    }
  }

  searchProject() {
    let pagination = new Pagination;
    pagination.conditionalCriteria = [
      {
        columnName: "search_word",
        operator: "=",
        value: this.projectForm.value.criteria,
      },
    ]
    this.searchedProjects$ = this.projectCoaService
      .getByCriteria(pagination, AppConfig.apiVisa)
      .pipe(
        map((response) => {
          return response.data
            .map((inner) => (
              {
                guid : inner.bl_fi_mst_project.guid,
                code : inner.bl_fi_mst_project.code,
                name : inner.bl_fi_mst_project.name,
              }
            ))
        })
      );
  }

  removeProject(project: string): void {
    const index = this.projects.indexOf(project);
    if (index >= 0) {
      this.projects.splice(index, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_ProjectField({
        projects: this.projects,
      })
    );
  }

  onRowClickedProject(e: any) {
    if (this.projects.includes(e)) {
      this.snackBar.open(`This Project is already in the selected list`);
    }
    else {
      this.projects.push(e);
      this.viewModelStore.dispatch(
        this.ColumnViewActions.setAdvanceSearch_ProjectField({
          projects: this.projects,
        })
      );
      this.snackBar.open(`Project Selected`);
    }
  }

  basicSearch(e: string) {
    // let basicSearh;
    if (e !== null && e !== "") {
      let searchCriteria = {
        keyWordSearch: e,
      };
      this.search.emit(searchCriteria);
    } else {
      let searchCriteria = {
        resetListing: true,
        isEmpty: true,
      };
      this.search.emit(searchCriteria);
    }
  }

  advancedSearch() {
    // console.log("Running advanced search")
    let isEmpty: boolean = true;
    this.isAdvanced = false;
    if (this.inputArray.some((e) => e.includes("branch"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Branch_Field)
        .subscribe((data) => {
          this.branchGuids = data.map((obj) => obj.guid);

          if (this.branchGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("purchaser"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Purchaser_Field)
        .subscribe((data) => {
          this.purchaserGuids = data.map(
            (obj) => obj.bl_fi_mst_entity_hdr.guid
          );
          if (this.purchaserGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("company"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Company_Field)
        .subscribe((data) => {
          this.companyGuids = data.map((obj) => obj.guid);

          if (this.companyGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("locationFrom"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_LocationFrom_Field)
        .subscribe((data) => {
          this.locationGuidsFrom = data.map((obj) => obj.guid);

          if (this.locationGuidsFrom.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("locationTo"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_LocationTo_Field)
        .subscribe((data) => {
          this.locationGuidsTo = data.map((obj) => obj.guid);

          if (this.locationGuidsTo.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("customer"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Customer_Field)
        .subscribe((data) => {
          // console.log("Customers", data);
          this.customerGuids = data.map((obj) => obj.guid);

          if (this.customerGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("entity"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Entity_Field)
        .subscribe((data) => {
          // console.log("Entities", data);
          this.entityGuids = data.map((obj) => obj.guid);

          if (this.entityGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("supplier"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Supplier_Field)
        .subscribe((data) => {
          this.supplierGuids = data.map((obj) => obj.guid);

          if (this.supplierGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("salesAgent"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_SalesAgent_Field)
        .subscribe((data) => {
          this.salesAgentGuids = data.map((obj) => obj.guid);

          if (this.salesAgentGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("deliveryRegion"))) {
      this.viewModelStore
        .select(
          this.ColumnViewSelectors.selectAdvanceSearch_DeliveryRegion_Field
        )
        .subscribe((data) => {
          this.deliveryRegionGuids = data.map((obj) => obj.guid);

          if (this.deliveryRegionGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("warehouse"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Warehouse_Field)
        .subscribe((data) => {
          this.warehouseGuids = data.map((obj) => obj.guid);
          // console.log("warehouseGuids", this.warehouseGuids)
          if (this.warehouseGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("cashbook"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Cashbook_Field)
        .subscribe((data) => {
          this.cashbookGuids = data.map((obj) => obj.guid);
          if (this.cashbookGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("budgetItem"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_BudgetItem_Field)
        .subscribe((data) => {
          this.budgetItemGuids = data.map((obj) => obj.guid);
          if (this.budgetItemGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("budgetRegister"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_BudgetRegister_Field)
        .subscribe((data) => {
          this.budgetRegisterGuids = data.map((obj) => obj.guid);
          if (this.budgetRegisterGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("budgetFiscalYear"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_BudgetFiscalYear_Field)
        .subscribe((data) => {
          this.budgetFiscalYearGuids = data.map((obj) => obj.guid);
          if (this.budgetFiscalYearGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("glDimension"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_GlDimension_Field)
        .subscribe((data) => {
          console.log("Gl Dimensions", data);
          this.glDimensionGuids = data.map((obj) => obj.guid);
          if (this.glDimensionGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("segment"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Segment_Field)
        .subscribe((data) => {
          console.log("Segments", data);
          this.segmentGuids = data.map((obj) => obj.guid);
          if (this.segmentGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("profitCenter"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_ProfitCenter_Field)
        .subscribe((data) => {
          console.log("Profit Centers", data);
          this.profitCenterGuids = data.map((obj) => obj.guid);
          if (this.profitCenterGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.inputArray.some((e) => e.includes("project"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Project_Field)
        .subscribe((data) => {
          console.log("Projects", data);
          this.projectGuids = data.map((obj) => obj.guid);
          if (this.projectGuids.length > 0) {
            isEmpty = false;
          }
        });
    }

    if (this.advForm.get("creationDate.from")?.value) {
      isEmpty = false;
    }
    if (this.advForm.get("estimateDate")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("creationDate.to")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("transactionDate.from")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("transactionDate.to")?.value) {
      isEmpty = false;
    }

    //for postdated cheque
    if (this.advForm.get("chequeDate.from")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("chequeDate.to")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("depositStartDate.from")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("depositStartDate.to")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("transactionDate.from")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("transactionDate.to")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("maturityEndDate.from")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("maturityEndDate.to")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("docNo")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("payee")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("amountDebit")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("amountCredit")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("depositAmount.from")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("depositAmount.to")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("maturityAmount.from")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("maturityAmount.to")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("interestRate.from")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("interestRate.to")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("estInterestAmount.from")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("estInterestAmount.to")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("actualInterestAmount.from")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("actualInterestAmount.to")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("trackingId")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("ref")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("desc")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("mktOrderNo")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("postingStatus")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("transactionType")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("status")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("interestType")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("autoRollOver")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("orderBy")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("itemCode")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("itemType")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("subType")?.value) {
      isEmpty = false;
    }

    if (this.advForm.get("balanceGreaterThan")?.value) {
      isEmpty = false;
    }

    let searchCriteria = {
      created_date_from: this.advForm.get("creationDate.from")?.value
        ? moment(this.advForm.get("creationDate.from").value).format(
            "YYYY-MM-DDT00:00:01.000Z"
          )
        : "",
        delivery_date_expected_from: this.advForm.get("estimateDeliveryDate.from")?.value
        ? moment(this.advForm.get("estimateDeliveryDate.from").value).format(
            "YYYY-MM-DDT00:00:01.000Z"
          )
        : "",
        delivery_date_expected_to: this.advForm.get("estimateDeliveryDate.to")?.value
        ? moment(this.advForm.get("estimateDeliveryDate.to").value).format(
            "YYYY-MM-DDT23:59:59.000Z"
          )
        : "",
      created_date_to: this.advForm.get("creationDate.to")?.value
        ? moment(this.advForm.get("creationDate.to").value).format(
            "YYYY-MM-DDT23:59:59.000Z"
          )
        : "",
      transaction_date_from: this.advForm.get("transactionDate.from")?.value
        ? moment(this.advForm.get("transactionDate.from").value).format(
            "YYYY-MM-DDT00:00:01.000Z"
          )
        : "",
      transaction_date_to: this.advForm.get("transactionDate.to")?.value
        ? moment(this.advForm.get("transactionDate.to").value).format(
            "YYYY-MM-DDT23:59:59.000Z"
          )
        : "",
      updated_date_from: this.advForm.get("updatedDate.from")?.value
        ? moment(this.advForm.get("updatedDate.from").value).format(
            "YYYY-MM-DDT00:00:01.000Z"
          )
        : "",
      updated_date_to: this.advForm.get("updatedDate.to")?.value
        ? moment(this.advForm.get("updatedDate.to").value).format(
            "YYYY-MM-DDT23:59:59.000Z"
          )
        : "",
      cheque_date_from: this.advForm.get("chequeDate.from")?.value
        ? moment(this.advForm.get("chequeDate.from").value).format(
            "YYYY-MM-DDT00:00:01.000Z"
          )
        : "",
      cheque_date_to: this.advForm.get("chequeDate.to")?.value
        ? moment(this.advForm.get("chequeDate.to").value).format(
            "YYYY-MM-DDT23:59:59.000Z"
          )
        : "",

      deposit_start_date_from: this.advForm.get("depositStartDate.from")?.value
        ? moment(this.advForm.get("depositStartDate.from").value).format(
            "YYYY-MM-DDT00:00:01.000Z"
          )
        : "",
      deposit_start_date_to: this.advForm.get("depositStartDate.to")?.value
        ? moment(this.advForm.get("depositStartDate.to").value).format(
            "YYYY-MM-DDT23:59:59.000Z"
          )
        : "",
      maturity_end_date_from: this.advForm.get("maturityEndDate.from")?.value
        ? moment(this.advForm.get("maturityEndDate.from").value).format(
            "YYYY-MM-DDT00:00:01.000Z"
          )
        : "",
      maturity_end_date_to: this.advForm.get("maturityEndDate.to")?.value
        ? moment(this.advForm.get("maturityEndDate.to").value).format(
            "YYYY-MM-DDT23:59:59.000Z"
          )
        : "",

      branchGuids: this.branchGuids,
      purchaserGuids: this.purchaserGuids,
      companyGuids: this.companyGuids,
      locationGuidsFrom: this.locationGuidsFrom,
      locationGuidsTo: this.locationGuidsTo,
      customerGuids: this.customerGuids,
      entityGuids: this.entityGuids,
      supplierGuids: this.supplierGuids,
      salesAgentGuids: this.salesAgentGuids,
      deliveryRegionGuids: this.deliveryRegionGuids,
      warehouseGuids: this.warehouseGuids,
      cashbookGuids: this.cashbookGuids,
      budgetItemGuids: this.budgetItemGuids,
      budgetRegisterGuids: this.budgetRegisterGuids,
      budgetFiscalYearGuids: this.budgetFiscalYearGuids,
      glDimensionGuids: this.glDimensionGuids,
      segmentGuids: this.segmentGuids,
      profitCenterGuids: this.profitCenterGuids,
      projectGuids: this.projectGuids,
      resetListing: this.resetListing,
      docNo: this.advForm.get("docNo")?.value
        ? this.advForm.get("docNo")?.value
        : "",
      trackingIds: this.advForm.get("trackingId")?.value
        ? this.advForm.get("trackingId")?.value
        : "",
      refNumbers: this.advForm.get("ref")?.value
        ? this.advForm.get("ref")?.value
        : "",
      docDesc: this.advForm.get("desc")?.value
        ? this.advForm.get("desc")?.value
        : "",
      mktOrderNo: this.advForm.get("mktOrderNo")?.value
        ? this.advForm.get("mktOrderNo")?.value
        : "",
      postingStatus: this.advForm.get("postingStatus")?.value
        ? this.advForm.get("postingStatus")?.value
        : "",

      deposit_amount_from: this.advForm.get("depositAmount.from")?.value
        ? this.advForm.get("depositAmount.from")?.value
        : null,
      deposit_amount_to: this.advForm.get("depositAmount.to")?.value
        ? this.advForm.get("depositAmount.to")?.value
        : null,

      maturity_amount_from: this.advForm.get("maturityAmount.from")?.value
        ? this.advForm.get("maturityAmount.from")?.value
        : null,
      maturity_amount_to: this.advForm.get("maturityAmount.to")?.value
        ? this.advForm.get("maturityAmount.to")?.value
        : null,

      interest_rate_from: this.advForm.get("interestRate.from")?.value
        ? this.advForm.get("interestRate.from")?.value
        : null,
      interest_rate_to: this.advForm.get("interestRate.to")?.value
        ? this.advForm.get("interestRate.to")?.value
        : null,

      est_interest_amount_from: this.advForm.get("estInterestAmount.from")
        ?.value
        ? this.advForm.get("estInterestAmount.from")?.value
        : null,
      est_interest_amount_to: this.advForm.get("estInterestAmount.to")?.value
        ? this.advForm.get("estInterestAmount.to")?.value
        : null,

      actual_interest_amount_from: this.advForm.get("actualInterestAmount.from")
        ?.value
        ? this.advForm.get("actualInterestAmount.from")?.value
        : null,
      actual_interest_amount_to: this.advForm.get("actualInterestAmount.to")
        ?.value
        ? this.advForm.get("actualInterestAmount.to")?.value
        : null,

      transactionType: this.advForm.get("transactionType")?.value
        ? this.advForm.get("transactionType")?.value
        : "",
      status: this.advForm.get("status")?.value
        ? this.advForm.get("status")?.value
        : "",
      interestType: this.advForm.get("interestType")?.value
        ? this.advForm.get("interestType")?.value
        : "",
      autoRollOver: this.advForm.get("autoRollOver")?.value
        ? this.advForm.get("autoRollOver")?.value
        : "",
      orderBy: this.advForm.get("orderBy")?.value
        ? this.advForm.get("orderBy")?.value
        : "",
      payee: this.advForm.get("payee")?.value
        ? this.advForm.get("payee")?.value
        : "",
      amountDebit: this.advForm.get("amountDebit")?.value
        ? this.advForm.get("amountDebit")?.value
        : 0,
      amountCredit: this.advForm.get("amountCredit")?.value
        ? this.advForm.get("amountCredit")?.value
        : 0,
      itemCode: this.advForm.get("itemCode")?.value
        ? this.advForm.get("itemCode")?.value
        : "",
      itemType: this.advForm.get("itemType")?.value
        ? this.advForm.get("itemType")?.value
        : "",
      subType: this.advForm.get("subType")?.value
        ? this.advForm.get("subType")?.value
        : "",
      balanceGreaterThan: this.advForm.get("balanceGreaterThan")?.value
        ? this.advForm.get("balanceGreaterThan")?.value
        : "",
      isEmpty: isEmpty,
    };
    if (!this.includeTxnDateControl.value) {
      delete searchCriteria["transaction_date_from"];
      delete searchCriteria["transaction_date_to"];
    }
    if (!this.includeCreationDateControl.value) {
      delete searchCriteria["created_date_from"];
      delete searchCriteria["created_date_to"];
    }
    if (!this.includeEstimateDeliveryDateControl.value) {
      delete searchCriteria["delivery_date_expected_from"];
      delete searchCriteria["delivery_date_expected_to"];
    }
    if (!this.includeChequeDateControl.value) {
      delete searchCriteria["cheque_date_from"];
      delete searchCriteria["cheque_date_to"];
    }
    this.search.emit(searchCriteria);
    this.resetListing = false;
  }

  toggleDropdown() {
    this.customerSearch = false;
    this.supplierSearch = false;
    this.entitySearch = false;
    this.glDimensionSearch = false;
    this.segmentSearch = false;
    this.profitCenterSearch = false;
    this.projectSearch = false;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
